import Footer from "../components/general/Footer";
import Header from "../components/general/Header";
import "../styles/lost/lost.css";

const Lost = () => {
  return (
    <div id="___gatsby">
      <div style={{ outline: "none" }} tabIndex={-1} id="gatsby-focus-wrapper">
        <div className="DefaultLayout__BackgroundContainer-sc-1h2qfsw-0 bzHVOS">
          <Header />

          <section className="sc-404__SectionNotFound-sc-1rxtu35-0 iCdOPX">
            <div className="Container-sc-rx245t-0 dGblwP">
              <div className="sc-404__NotFoundImage-sc-1rxtu35-1 EdpZY">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={684}
                  height={267}
                  viewBox="0 0 684 267"
                  fill="none"
                  className="sc-404__StyledSvg404-sc-1rxtu35-2 jJuMnu"
                >
                  <path
                    d="M487.818 39.3359C491.602 39.3359 494.67 36.2743 494.67 32.4975C494.67 28.7208 491.602 25.6591 487.818 25.6591C484.033 25.6591 480.965 28.7208 480.965 32.4975C480.965 36.2743 484.033 39.3359 487.818 39.3359Z"
                    fill="url(#paint0_linear_8_104)"
                  />
                  <path
                    d="M71.0137 242.612C74.7984 242.612 77.8665 239.55 77.8665 235.773C77.8665 231.997 74.7984 228.935 71.0137 228.935C67.2291 228.935 64.161 231.997 64.161 235.773C64.161 239.55 67.2291 242.612 71.0137 242.612Z"
                    fill="url(#paint1_linear_8_104)"
                  />
                  <path
                    d="M215.71 229.964C219.494 229.964 222.562 226.902 222.562 223.125C222.562 219.349 219.494 216.287 215.71 216.287C211.925 216.287 208.857 219.349 208.857 223.125C208.857 226.902 211.925 229.964 215.71 229.964Z"
                    fill="url(#paint2_linear_8_104)"
                  />
                  <path
                    d="M31.3528 62.0297C35.1374 62.0297 38.2055 58.968 38.2055 55.1913C38.2055 51.4146 35.1374 48.3529 31.3528 48.3529C27.5681 48.3529 24.5 51.4146 24.5 55.1913C24.5 58.968 27.5681 62.0297 31.3528 62.0297Z"
                    fill="url(#paint3_linear_8_104)"
                  />
                  <path
                    d="M566.291 256.289C570.075 256.289 573.143 253.227 573.143 249.45C573.143 245.673 570.075 242.612 566.291 242.612C562.506 242.612 559.438 245.673 559.438 249.45C559.438 253.227 562.506 256.289 566.291 256.289Z"
                    fill="url(#paint4_linear_8_104)"
                  />
                  <path
                    d="M531.966 228.209C533.741 228.209 535.18 226.773 535.18 225.001C535.18 223.23 533.741 221.794 531.966 221.794C530.191 221.794 528.752 223.23 528.752 225.001C528.752 226.773 530.191 228.209 531.966 228.209Z"
                    fill="url(#paint5_linear_8_104)"
                  />
                  <path
                    d="M468.23 122.002C470.005 122.002 471.444 120.566 471.444 118.794C471.444 117.023 470.005 115.587 468.23 115.587C466.455 115.587 465.016 117.023 465.016 118.794C465.016 120.566 466.455 122.002 468.23 122.002Z"
                    fill="url(#paint6_linear_8_104)"
                  />
                  <path
                    d="M215.71 122.002C217.485 122.002 218.924 120.566 218.924 118.794C218.924 117.023 217.485 115.587 215.71 115.587C213.934 115.587 212.495 117.023 212.495 118.794C212.495 120.566 213.934 122.002 215.71 122.002Z"
                    fill="url(#paint7_linear_8_104)"
                  />
                  <path
                    d="M680.725 122.002C682.5 122.002 683.939 120.566 683.939 118.794C683.939 117.023 682.5 115.587 680.725 115.587C678.95 115.587 677.511 117.023 677.511 118.794C677.511 120.566 678.95 122.002 680.725 122.002Z"
                    fill="url(#paint8_linear_8_104)"
                  />
                  <path
                    d="M344.335 229.177C403.483 229.177 451.431 181.329 451.431 122.304C451.431 63.2803 403.483 15.4318 344.335 15.4318C285.187 15.4318 237.238 63.2803 237.238 122.304C237.238 181.329 285.187 229.177 344.335 229.177Z"
                    fill="#2D54DE"
                  />
                  <path
                    d="M371.928 113.348C364.832 90.4726 306.008 105.36 310.678 130.535L312.133 135.194C312.376 134.166 312.8 128.961 313.407 127.509C313.407 127.448 313.831 126.541 313.892 126.541L314.074 126.238L314.134 126.117C314.256 125.935 315.044 124.544 316.014 123.333C316.075 123.212 317.834 121.276 318.197 120.913C317.045 116.495 316.984 116.253 318.197 120.913L318.258 120.852C326.263 112.864 339.786 108.204 350.884 107.962C352.037 107.538 359.071 108.507 361.194 109.051C361.194 109.051 361.497 109.112 361.558 109.112C363.134 109.535 365.196 110.322 365.318 110.443C365.681 110.564 366.409 110.988 366.834 111.169C366.955 111.29 369.199 112.44 370.533 113.772C370.836 114.074 371.139 114.437 371.261 114.74C371.564 115.042 371.988 115.769 372.049 115.829V115.769C372.049 115.769 372.049 115.769 372.049 115.829C372.11 115.95 373.019 117.403 373.08 117.887C373.08 117.947 373.141 118.008 373.141 118.068C373.201 118.25 373.322 118.552 373.383 118.915C371.139 110.262 371.746 112.38 371.928 113.348ZM371.928 113.348V113.408V113.348ZM372.049 114.498V114.619C372.049 114.619 372.049 114.498 372.049 114.498ZM371.988 114.921C371.988 114.921 371.988 114.982 371.988 115.103C371.988 115.163 371.988 115.284 371.988 115.345C371.988 115.163 371.988 114.921 371.988 114.921Z"
                    fill="url(#paint9_linear_8_104)"
                  />
                  <path
                    d="M373.322 118.915C372.291 114.135 367.986 110.201 360.769 108.264C346.942 104.573 327.597 109.717 317.53 119.823C312.679 124.665 310.859 129.808 311.89 134.226C312.982 138.947 317.227 142.88 324.383 144.817C338.21 148.508 357.555 143.364 367.622 133.258C372.413 128.417 374.232 123.333 373.322 118.915Z"
                    fill="url(#paint10_linear_8_104)"
                  />
                  <path
                    d="M328.628 140.52C318.015 137.676 315.65 129.143 323.352 121.397C331.054 113.651 345.911 109.717 356.524 112.561C367.137 115.405 369.502 123.938 361.8 131.685C354.038 139.37 339.241 143.364 328.628 140.52ZM357.131 111.956C346.093 108.991 330.629 113.166 322.564 121.215C314.559 129.264 316.984 138.22 328.022 141.186C339.059 144.151 354.523 139.975 362.588 131.927C370.593 123.817 368.168 114.921 357.131 111.956Z"
                    fill="url(#paint11_linear_8_104)"
                  />
                  <path
                    d="M335.966 130.232L339.786 126.42L343.304 127.327C348.216 128.659 343.364 132.169 339.786 131.2C336.39 130.353 335.966 130.232 335.966 130.232ZM342.212 123.938L345.548 120.61L349.004 121.518C352.825 122.546 348.701 125.693 345.669 124.846C342.455 123.999 342.212 123.938 342.212 123.938ZM350.642 115.466L348.519 114.921L345.79 117.645C342.576 116.797 340.575 116.253 340.575 116.253L338.877 117.887L339.665 118.613L341.97 118.673L331.296 129.385L328.204 128.538L326.384 130.414L327.051 131.2L331.66 131.806L328.992 134.529L329.659 135.194L331.114 135.073L333.783 132.35L336.148 132.955L333.419 135.679L334.147 136.405L335.541 136.284L338.27 133.561C348.337 136.223 355.19 128.356 348.337 126.541C353.007 127.811 362.407 122.365 352.461 119.339L355.918 117.342L355.19 116.616L353.067 116.071L350.339 118.794L347.973 118.189L351.369 116.132L350.642 115.466Z"
                    fill="#D97100"
                  />
                  <path
                    d="M336.694 130.958L340.514 127.146L344.032 128.053C348.944 129.385 344.092 132.895 340.514 131.927C337.118 131.019 336.694 130.958 336.694 130.958ZM342.94 124.665L346.275 121.336L349.732 122.244C353.553 123.273 349.429 126.42 346.397 125.572C343.122 124.725 342.94 124.665 342.94 124.665ZM351.369 116.192L349.247 115.648L346.518 118.371C343.304 117.524 341.303 116.979 341.303 116.979L339.605 118.613L342.697 119.46L332.024 130.172L328.931 129.324L327.112 131.2L332.327 132.592L329.659 135.316L331.782 135.86L334.45 133.137L336.815 133.742L334.086 136.465L336.209 137.01L338.938 134.287C349.004 136.949 355.857 129.082 349.004 127.267C353.674 128.538 361.982 122.789 353.128 120.065L355.857 117.342L353.735 116.797L351.006 119.521L348.641 118.915L351.369 116.192Z"
                    fill="white"
                  />
                  <path
                    d="M126.867 196.195H10.9159L0 149.476L124.138 1.99706H191.149V146.693H221.592V196.195H191.149V242.612H126.867V196.195ZM126.867 147.056V78.4902L69.7402 147.056H126.867Z"
                    fill="url(#paint12_linear_8_104)"
                  />
                  <path
                    d="M589.275 196.195H473.324L462.408 149.416L586.485 1.99706H653.496V146.693H683.939V196.195H653.496V242.612H589.214V196.195H589.275ZM589.275 147.056V78.4902L532.148 147.056H589.275Z"
                    fill="url(#paint13_linear_8_104)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_8_104"
                      x1="487.836"
                      y1="25.673"
                      x2="487.836"
                      y2="39.3542"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_8_104"
                      x1="70.9857"
                      y1="228.949"
                      x2="70.9857"
                      y2="242.63"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_8_104"
                      x1="215.708"
                      y1="216.262"
                      x2="215.708"
                      y2="229.944"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_8_104"
                      x1="31.3756"
                      y1="48.3649"
                      x2="31.3756"
                      y2="62.0461"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint4_linear_8_104"
                      x1="566.317"
                      y1="242.63"
                      x2="566.317"
                      y2="256.311"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint5_linear_8_104"
                      x1="531.988"
                      y1="221.769"
                      x2="531.988"
                      y2="228.234"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint6_linear_8_104"
                      x1="468.234"
                      y1="115.592"
                      x2="468.234"
                      y2="122.057"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint7_linear_8_104"
                      x1="215.708"
                      y1="115.592"
                      x2="215.708"
                      y2="122.057"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint8_linear_8_104"
                      x1="680.74"
                      y1="115.592"
                      x2="680.74"
                      y2="122.057"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint9_linear_8_104"
                      x1="360.937"
                      y1="104.609"
                      x2="310.227"
                      y2="142.94"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#F39800" />
                      <stop offset={1} stopColor="#C55300" />
                    </linearGradient>
                    <linearGradient
                      id="paint10_linear_8_104"
                      x1="326.688"
                      y1="110.677"
                      x2="358.387"
                      y2="142.443"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9D00" />
                      <stop offset="0.2377" stopColor="#FFAA00" />
                      <stop offset="0.5419" stopColor="#FFB300" />
                      <stop offset={1} stopColor="#FFB600" />
                    </linearGradient>
                    <linearGradient
                      id="paint11_linear_8_104"
                      x1="324.051"
                      y1="144.037"
                      x2="353.943"
                      y2="115.659"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FFFF54" stopOpacity={0} />
                      <stop offset="0.996" stopColor="#CA5A00" />
                    </linearGradient>
                    <linearGradient
                      id="paint12_linear_8_104"
                      x1="110.808"
                      y1="-181.547"
                      x2="110.808"
                      y2="237.39"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADCFC" />
                    </linearGradient>
                    <linearGradient
                      id="paint13_linear_8_104"
                      x1="573.172"
                      y1="-181.547"
                      x2="573.172"
                      y2="237.39"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" />
                      <stop offset={1} stopColor="#CADBFC" />
                    </linearGradient>
                  </defs>
                </svg>
                <div className="sc-404__NotFoundUfoBlock-sc-1rxtu35-3 hBJKYM">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={236}
                    height={238}
                    viewBox="0 0 236 238"
                    fill="none"
                    className="sc-404__StyledSvgUFO-sc-1rxtu35-4 gquIBw"
                  >
                    <path
                      d="M152.356 72.8017L124.642 72.8622L83.5253 72.9227L31.675 237.226H124.642H205.055L152.356 72.8017Z"
                      fill="url(#paint0_linear_8_140)"
                    />
                    <path
                      d="M156.983 93.0961C178.321 71.8028 178.321 37.2794 156.983 15.986C135.645 -5.30737 101.049 -5.30735 79.7108 15.986C58.3728 37.2794 58.3728 71.8027 79.7108 93.0961C101.049 114.389 135.645 114.39 156.983 93.0961Z"
                      fill="#D6E3FC"
                    />
                    <path
                      d="M172.853 54.5256C172.853 54.5256 154.721 65.7212 117.91 65.7212C81.0996 65.7212 63.4523 54.5256 63.4523 54.5256C63.4523 54.5256 0.322205 72.6807 0.322205 85.2076C0.322205 97.7346 71.154 108.991 117.91 108.991C164.667 108.991 235.741 97.7346 235.741 85.2076C235.802 72.6807 172.853 54.5256 172.853 54.5256Z"
                      fill="#3071EE"
                    />
                    <path
                      d="M60.9052 55.1913C60.9052 55.1913 67.0908 87.6888 106.994 87.6888C146.898 87.6888 174.491 57.1278 174.491 57.1278C174.491 57.1278 157.207 62.5138 117.91 62.5138C78.6738 62.5743 60.9052 55.1913 60.9052 55.1913Z"
                      fill="#2D54DE"
                    />
                    <path
                      d="M77.163 92.0591C82.7994 86.4344 82.7994 77.315 77.1629 71.6904C71.5265 66.0657 62.388 66.0657 56.7515 71.6904C51.1151 77.315 51.1151 86.4344 56.7515 92.0591C62.388 97.6837 71.5265 97.6837 77.163 92.0591Z"
                      fill="white"
                    />
                    <path
                      d="M183.8 85.2293C185.646 77.4911 180.857 69.7246 173.102 67.8823C165.348 66.04 157.565 70.8196 155.719 78.5578C153.873 86.296 158.662 94.0625 166.417 95.9048C174.171 97.7471 181.954 92.9675 183.8 85.2293Z"
                      fill="white"
                    />
                    <path
                      d="M169.761 92.8932C175.856 92.8932 180.798 87.9621 180.798 81.8792C180.798 75.7963 175.856 70.8651 169.761 70.8651C163.665 70.8651 158.723 75.7963 158.723 81.8792C158.723 87.9621 163.665 92.8932 169.761 92.8932Z"
                      fill="#D6E3FC"
                    />
                    <path
                      d="M118.36 102.154C126.331 102.109 132.757 95.6252 132.713 87.6706C132.669 79.7161 126.171 73.3034 118.2 73.3475C110.228 73.3917 103.802 79.8759 103.846 87.8304C103.891 95.785 110.388 102.198 118.36 102.154Z"
                      fill="white"
                    />
                    <path
                      opacity="0.5"
                      d="M161.756 39.0938C161.756 41.3935 159.876 43.2695 157.571 43.2695C155.267 43.2695 153.387 41.3935 153.387 39.0938C153.387 36.7942 155.267 34.9182 157.571 34.9182C159.876 34.9182 161.756 36.7942 161.756 39.0938Z"
                      fill="white"
                    />
                    <path
                      d="M117.91 68.8076C80.6751 68.8076 62.5426 57.612 61.7543 57.1278C60.2988 56.2201 59.8743 54.2835 60.784 52.8311C61.6936 51.3787 63.6342 50.9551 65.0897 51.8629C65.2716 51.9839 82.6157 62.5743 117.91 62.5743C153.205 62.5743 171.034 51.9839 171.216 51.8629C172.672 50.9551 174.612 51.4393 175.522 52.8917C176.431 54.3441 175.946 56.2806 174.491 57.1884C173.763 57.6725 155.146 68.8076 117.91 68.8076Z"
                      fill="#6E9CF3"
                    />
                    <path
                      opacity="0.5"
                      d="M169.761 70.8651C169.215 70.8651 168.669 70.9257 168.184 70.9862L159.209 85.0866C159.936 87.4468 161.392 89.5043 163.393 90.8962L175.219 72.3175C173.581 71.3493 171.762 70.8651 169.761 70.8651Z"
                      fill="white"
                    />
                    <path
                      opacity="0.5"
                      d="M177.523 74.012L165.94 92.2276C167.153 92.6512 168.426 92.8933 169.761 92.8933C169.943 92.8933 170.064 92.8933 170.246 92.8933L180.009 77.643C179.403 76.2511 178.554 75.0408 177.523 74.012Z"
                      fill="white"
                    />
                    <path
                      d="M122.36 97.8997C127.983 95.5517 130.634 89.0993 128.282 83.4878C125.929 77.8763 119.463 75.2307 113.839 77.5787C108.216 79.9267 105.565 86.3792 107.918 91.9906C110.271 97.6021 116.737 100.248 122.36 97.8997Z"
                      fill="#D6E3FC"
                    />
                    <path
                      opacity="0.5"
                      d="M118.092 76.6747C117.546 76.6747 117.001 76.7353 116.515 76.7958L107.54 90.8962C108.268 93.2563 109.723 95.3139 111.725 96.7058L123.55 78.1272C121.913 77.2194 120.033 76.6747 118.092 76.6747Z"
                      fill="white"
                    />
                    <path
                      opacity="0.5"
                      d="M125.855 79.8821L114.211 98.0977C115.424 98.5213 116.697 98.7634 118.032 98.7634C118.213 98.7634 118.335 98.7634 118.517 98.7634L128.28 83.5131C127.735 82.1213 126.886 80.9109 125.855 79.8821Z"
                      fill="white"
                    />
                    <path
                      d="M66.9696 92.8932C73.0653 92.8932 78.0067 87.9621 78.0067 81.8792C78.0067 75.7963 73.0653 70.8651 66.9696 70.8651C60.8739 70.8651 55.9324 75.7963 55.9324 81.8792C55.9324 87.9621 60.8739 92.8932 66.9696 92.8932Z"
                      fill="#D6E3FC"
                    />
                    <path
                      opacity="0.5"
                      d="M66.9696 70.8651C66.4238 70.8651 65.878 70.9257 65.3928 70.9862L56.4176 85.0866C57.1453 87.4468 58.6007 89.5043 60.602 90.8962L72.4275 72.3175C70.7901 71.3493 68.9102 70.8651 66.9696 70.8651Z"
                      fill="white"
                    />
                    <path
                      opacity="0.5"
                      d="M74.732 74.012L63.149 92.2276C64.3619 92.6512 65.6354 92.8932 66.9696 92.8932C67.1515 92.8932 67.2728 92.8932 67.4547 92.8932L77.2184 77.643C76.6119 76.2511 75.7629 75.0408 74.732 74.012Z"
                      fill="white"
                    />
                    <path
                      opacity="0.5"
                      d="M118.335 0C108.753 0 99.7778 2.48119 91.9548 6.77788C92.6825 6.47529 117.668 -3.32842 142.714 10.5904C167.638 24.5093 172.672 50.471 172.853 51.3182C171.216 22.6938 147.444 0 118.335 0Z"
                      fill="white"
                    />
                    <path
                      d="M235.802 85.2076C235.802 74.0725 186.559 58.6408 175.219 55.1913C175.219 55.1913 224.643 73.891 225.856 83.3921C227.069 92.8933 200.568 100.458 200.568 100.458L218.579 96.0401C229.131 92.7117 235.802 89.0807 235.802 85.2076Z"
                      fill="#6E9CF3"
                    />
                    <path
                      d="M0.322205 85.2076C0.322205 74.0725 49.5649 58.6408 60.9052 55.1913C60.9052 55.1913 11.4806 73.891 10.2678 83.3921C9.05489 92.8933 35.5562 100.458 35.5562 100.458L17.545 96.0401C6.99301 92.7117 0.322205 89.0807 0.322205 85.2076Z"
                      fill="#6E9CF3"
                    />
                    <path
                      d="M104.387 39.3359V48.1108L109.178 44.0562L108.814 43.6931L104.387 39.3359Z"
                      fill="white"
                    ></path>
                    <path
                      d="M104.387 29.6532V20.8178L118.092 32.3765V41.1514L104.387 29.6532Z"
                      fill="white"
                    />
                    <path
                      opacity="0.5"
                      d="M131.798 39.3359V48.1108L127.007 44.0562L127.371 43.6931L131.798 39.3359Z"
                      fill="white"
                    />
                    <path
                      opacity="0.5"
                      d="M131.798 20.8178V29.6532L118.092 41.2119V32.3765L131.798 20.8178Z"
                      fill="white"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_8_140"
                        x1="118.358"
                        y1="72.8297"
                        x2="118.358"
                        y2="237.215"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="white" />
                        <stop
                          offset="0.0985309"
                          stopColor="#F7F8FB"
                          stopOpacity="0.9015"
                        />
                        <stop
                          offset="0.4121"
                          stopColor="#E1E6EF"
                          stopOpacity="0.5879"
                        />
                        <stop
                          offset="0.7167"
                          stopColor="#D4DBE8"
                          stopOpacity="0.2833"
                        />
                        <stop offset={1} stopColor="#D0D7E6" stopOpacity={0} />
                      </linearGradient>
                    </defs>
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={63}
                    height={77}
                    viewBox="0 0 63 77"
                    fill="none"
                    className="sc-404__StyledSvgLCoin-sc-1rxtu35-5 bBCdXe"
                  >
                    <path
                      d="M48.2468 2.84246C21.5636 -11.1974 -17.5515 54.2817 9.07103 72.5578L14.529 75.4021C13.8012 74.2523 9.55618 69.2899 8.82846 67.4139C8.82846 67.3533 8.3433 66.143 8.3433 66.0825L8.22202 65.6589L8.16137 65.4773C8.10073 65.1747 7.55494 63.2987 7.37301 61.3622C7.31237 61.1806 7.13042 57.9127 7.13042 57.2471C2.21829 54.3422 1.91507 54.1607 7.13042 57.2471V57.1865C7.13042 42.9651 14.9535 26.8071 24.6565 16.7613C25.3235 15.3694 32.4188 9.98344 34.7839 8.53104L35.1478 8.28897C36.9065 7.3207 39.4535 6.11036 39.6961 6.11036C40.1206 5.92881 41.1515 5.56572 41.6973 5.44469C41.8792 5.44469 44.9114 4.47641 47.2765 4.47641C47.883 4.47641 48.3681 4.53693 48.7926 4.65797C49.2778 4.65797 50.3694 4.90003 50.4906 4.90003C50.4906 4.90003 50.4906 4.90003 50.5513 4.90003L50.4906 4.83952C50.4906 4.83952 50.4906 4.83951 50.5513 4.90003C50.7939 4.96055 52.7951 5.44468 53.2803 5.80778C53.3409 5.80778 53.4622 5.8683 53.4622 5.92881C53.6441 5.98933 54.008 6.17089 54.4325 6.47347C44.8508 0.784893 47.2765 2.17678 48.2468 2.84246ZM48.2468 2.84246L48.3075 2.90297C48.3075 2.90297 48.3075 2.90298 48.2468 2.84246ZM49.3991 3.81073L49.5204 3.93177C49.5204 3.87125 49.3991 3.81073 49.3991 3.81073ZM49.7629 4.17383C49.7629 4.17383 49.8236 4.23434 49.8842 4.29486C49.9448 4.35538 50.0055 4.4159 50.0661 4.47641C49.9449 4.35538 49.7629 4.17383 49.7629 4.17383Z"
                      fill="url(#paint0_linear_8_124)"
                    />
                    <path
                      d="M54.4931 6.59451C49.3384 3.26609 41.9399 3.50815 33.8136 8.22846C18.2282 17.2455 5.61432 39.0315 5.61432 56.9445C5.61432 65.5984 8.58587 71.7106 13.4374 74.7969C18.5921 78.0648 25.93 77.7622 33.9956 73.1024C49.581 64.0854 62.1949 42.2994 62.1949 24.3864C62.1342 15.7931 59.2233 9.68086 54.4931 6.59451Z"
                      fill="url(#paint1_linear_8_124)"
                    />
                    <path
                      d="M33.9956 65.4773C22.0488 72.3762 12.2851 66.8087 12.2851 53.1319C12.2245 39.3946 21.9275 22.692 33.8743 15.7931C45.8211 8.89415 55.5847 14.4617 55.5847 28.1385C55.5847 41.8758 45.9424 58.5784 33.9956 65.4773ZM33.8136 14.7643C21.321 21.9658 11.2542 39.3946 11.3148 53.6766C11.3755 67.9585 21.503 73.7681 33.9956 66.5666C46.4882 59.3651 56.555 41.9363 56.4944 27.6543C56.4337 13.3119 46.3062 7.56277 33.8136 14.7643Z"
                      fill="url(#paint2_linear_8_124)"
                    />
                    <path
                      d="M31.3272 49.8035V43.0256L35.2691 40.726C40.7876 37.5186 39.696 44.9621 35.6329 47.3223C31.8124 49.5009 31.3272 49.8035 31.3272 49.8035ZM31.3272 38.6684V32.7378L35.2084 30.4986C39.5141 28.0175 38.6651 34.4322 35.2084 36.4293C31.5698 38.5474 31.3272 38.6684 31.3272 38.6684ZM31.2666 23.6603L28.8409 25.0521V29.8935C25.2629 31.951 22.8978 33.2824 22.8978 33.2824V36.2477L24.2926 36.1872L26.4151 34.2507L26.4758 53.3135L22.9584 55.3105L23.0191 58.6389L24.2926 58.76L28.9015 55.25V60.0308H30.1144L31.3272 58.6389V53.8581L33.9956 52.3452V57.1865L35.2691 57.126L36.4213 55.7946V50.9533C47.7617 44.4175 46.852 31.2854 39.0896 35.7636C44.3656 32.7378 47.8829 19.5451 36.3 25.6573L37.5735 20.816H36.3L33.8743 22.2078V27.0492L31.2059 28.5621L32.4188 23.7208L31.2666 23.6603Z"
                      fill="#D97100"
                    />
                    <path
                      d="M32.6008 49.8035V43.0256L36.5426 40.726C42.0612 37.5186 40.9696 44.9621 36.9065 47.3223C33.0859 49.5009 32.6008 49.8035 32.6008 49.8035ZM32.6008 38.6684V32.7378L36.482 30.4986C40.7877 28.0175 39.9386 34.4322 36.482 36.4293C32.7827 38.5474 32.6008 38.6684 32.6008 38.6684ZM32.5401 23.6603L30.1144 25.0521V29.8935C26.5364 31.951 24.1713 33.2824 24.1713 33.2824V36.2477L27.6886 34.2507L27.7493 53.3135L24.2319 55.3105L24.2926 58.6389L30.2357 55.25V60.0308L32.6614 58.6389V53.8581L35.3297 52.3452V57.1865L37.7555 55.7946V50.9533C49.0958 44.4175 48.1862 31.2854 40.4238 35.7636C45.6998 32.7378 48.0042 20.2713 37.6342 25.6573V20.816L35.2084 22.2078V27.0492L32.5401 28.5621V23.6603Z"
                      fill="white"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_8_124"
                        x1="30.7039"
                        y1="4.83522"
                        x2="19.6438"
                        y2="83.9698"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#F39800" />
                        <stop offset={1} stopColor="#C55300" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_8_124"
                        x1="5.63512"
                        y1="40.6541"
                        x2="62.1761"
                        y2="40.6541"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FF9D00" />
                        <stop offset="0.2377" stopColor="#FFAA00" />
                        <stop offset="0.5419" stopColor="#FFB300" />
                        <stop offset={1} stopColor="#FFB600" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_8_124"
                        x1="33.0394"
                        y1="72.6846"
                        x2="34.4365"
                        y2="20.8847"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FFFF54" stopOpacity={0} />
                        <stop offset="0.996" stopColor="#CA5A00" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={65}
                    height={94}
                    viewBox="0 0 65 94"
                    fill="none"
                    className="sc-404__StyledSvgRCoin-sc-1rxtu35-6 jkMHlP"
                  >
                    <path
                      d="M16.8373 3.32955C-16.8806 13.7384 5.07245 100.096 42.247 93.318L49.0997 91.1999C47.5836 90.8973 39.9425 90.2316 37.7594 89.3239C37.6987 89.2634 36.3646 88.6582 36.3039 88.5977L35.8188 88.3556L35.6368 88.2346C35.3336 88.053 33.3324 86.9032 31.5737 85.5113C31.3311 85.4508 28.5415 82.8486 27.9351 82.3039C21.4462 83.9379 21.0824 84.0589 27.9351 82.3039L27.8745 82.2434C16.0489 70.4427 9.1962 50.6537 8.83234 34.3141C8.2259 32.5591 9.62072 22.2713 10.4091 19.1849C10.4091 19.1849 10.4091 19.1849 10.4091 19.1244L10.5304 18.6403C11.1975 16.3407 12.289 13.3148 12.471 13.1333C12.7135 12.6491 13.2594 11.4993 13.5626 10.8941C13.6839 10.7731 15.4425 7.44468 17.3831 5.50815C17.8683 5.02401 18.3534 4.66092 18.8385 4.41885C19.263 3.99523 20.3546 3.32955 20.4759 3.20852C20.4759 3.20852 20.4759 3.20852 20.5366 3.20852C20.4759 3.20852 20.4759 3.20852 20.4759 3.20852C20.4759 3.20852 20.4759 3.20852 20.5366 3.20852C20.7792 3.08748 22.9017 1.81663 23.5688 1.6956C23.6294 1.6956 23.7507 1.63508 23.8113 1.63508C24.0539 1.57456 24.4784 1.39301 25.0849 1.27197C12.2891 4.41884 15.5031 3.57162 16.8373 3.32955ZM16.8373 3.32955H16.9586C16.9586 3.32955 16.8979 3.32955 16.8373 3.32955ZM18.596 3.148H18.7779C18.7173 3.148 18.596 3.148 18.596 3.148ZM19.2024 3.20852C19.2024 3.20852 19.263 3.20852 19.445 3.20852C19.5663 3.20852 19.6876 3.20852 19.8089 3.20852C19.5056 3.20852 19.2024 3.20852 19.2024 3.20852Z"
                      fill="url(#paint0_linear_8_116)"
                    />
                    <path
                      d="M25.1455 1.27198C18.1108 2.7849 12.2283 9.07864 9.37809 19.6691C3.92016 40.0027 11.5613 68.4456 26.419 83.2117C33.5749 90.3526 41.1554 92.9549 47.6443 91.5025C54.6183 89.929 60.3794 83.6353 63.2297 73.1659C68.6876 52.8323 61.0465 24.3894 46.1888 9.62329C39.0935 2.54283 31.5737 -0.119907 25.1455 1.27198Z"
                      fill="url(#paint1_linear_8_116)"
                    />
                    <path
                      d="M56.9834 66.9326C52.799 82.4855 40.1851 85.9349 28.7841 74.6183C17.3831 63.3017 11.5613 41.5156 15.6851 25.9628C19.8695 10.41 32.4834 6.96056 43.8844 18.2772C55.2854 29.5333 61.1678 51.3193 56.9834 66.9326ZM14.7754 25.0551C10.4091 41.2736 16.5341 64.0279 28.4202 75.8286C40.3064 87.6294 53.4661 83.9984 57.8324 67.7799C62.1988 51.5614 56.0738 28.8071 44.1876 17.0063C32.3014 5.20558 19.1418 8.83659 14.7754 25.0551Z"
                      fill="url(#paint2_linear_8_116)"
                    />
                    <path
                      d="M41.7619 56.1002L36.122 50.5326L37.5168 45.3887C39.4574 38.1872 44.6727 45.2677 43.2779 50.5326C41.9438 55.495 41.7619 56.1002 41.7619 56.1002ZM32.544 46.9016L27.6319 41.9998L28.966 36.9164C30.4821 31.3488 35.0911 37.34 33.8782 41.8182C32.6047 46.599 32.544 46.9016 32.544 46.9016ZM20.0514 34.5562L19.2024 37.7031L23.2656 41.6972C21.992 46.357 21.2037 49.3828 21.2037 49.3828L23.6294 51.864L24.721 50.6537L24.8423 47.3252L40.6702 63.0596L39.4574 67.5984L42.247 70.3216L43.3992 69.3533L44.3089 62.636L48.3114 66.5696L49.2816 65.6013L49.0997 63.4227L45.0972 59.4891L46.0069 55.9791L50.0094 59.9732L51.0403 58.8839L50.8584 56.8264L46.8559 52.8323C50.7977 38.0662 39.1542 28.0204 36.4858 38.0662C38.3658 31.1673 30.3002 17.43 25.8126 32.0145L22.841 26.9311L21.8101 27.9599L20.9611 31.1068L24.9636 35.1008L24.0539 38.6108L21.0824 33.5879L20.0514 34.5562Z"
                      fill="#D97100"
                    />
                    <path
                      d="M42.7928 55.0109L37.1529 49.4433L38.5477 44.2994C40.4883 37.0979 45.7037 44.1784 44.3089 49.4433C42.9747 54.4662 42.7928 55.0109 42.7928 55.0109ZM33.575 45.8728L28.6628 40.971L29.997 35.8876C31.5131 30.32 36.122 36.3112 34.9091 40.7894C33.6356 45.5703 33.575 45.8728 33.575 45.8728ZM21.0824 33.5274L20.2334 36.6743L24.2965 40.6684C23.0229 45.3282 22.2346 48.354 22.2346 48.354L24.6603 50.8352L25.8732 46.2964L41.7012 62.0308L40.4883 66.5696L43.278 69.2928L45.3398 61.6072L49.3423 65.5408L50.1913 62.3939L46.1889 58.4603L47.0985 54.9504L51.101 58.9445L51.95 55.7976L47.9475 51.8035C51.8893 37.0374 40.2458 26.9916 37.5774 37.0374C39.4574 30.1385 31.0279 17.9746 26.9042 30.9857L22.841 26.9916L21.992 30.1385L25.9945 34.1326L25.0849 37.6426L21.0824 33.5274Z"
                      fill="white"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_8_116"
                        x1="3.99079"
                        y1="19.4466"
                        x2="60.2243"
                        y2="94.1535"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#F39800" />
                        <stop offset={1} stopColor="#C55300" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_8_116"
                        x1="12.9422"
                        y1="69.7478"
                        x2="59.5966"
                        y2="22.9955"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FF9D00" />
                        <stop offset="0.2377" stopColor="#FFAA00" />
                        <stop offset="0.5419" stopColor="#FFB300" />
                        <stop offset={1} stopColor="#FFB600" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_8_116"
                        x1="62.1432"
                        y1="73.6229"
                        x2="20.4733"
                        y2="29.5458"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FFFF54" stopOpacity={0} />
                        <stop offset="0.996" stopColor="#CA5A00" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height={26}
                    viewBox="0 0 229 26"
                    fill="none"
                    className="sc-404__StyledSvgShadow-sc-1rxtu35-7 kEDzJF"
                  >
                    <path
                      d="M114.335 26C177.468 26 228.648 20.3102 228.648 13.2915C228.648 6.27275 177.468 0.582947 114.335 0.582947C51.2012 0.582947 0.0214233 6.27275 0.0214233 13.2915C0.0214233 20.3102 51.2012 26 114.335 26Z"
                      fill="url(#paint0_linear_8_115)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_8_115"
                        x1="0.0321573"
                        y1="13.3015"
                        x2="228.685"
                        y2="13.3015"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="white" />
                        <stop offset={1} stopColor="#CADBFC" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
              <h1 className="sc-404__Title-sc-1rxtu35-8 eDqwyZ">
                Oops, something went wrong
              </h1>
              <div className="sc-404__Description-sc-1rxtu35-9 lcrvcn">
                Sorry, the page you visited does not exist.
              </div>
              <div className="sc-404__BtnBlock-sc-1rxtu35-10 iyKsra">
                <a href="/" className="sc-404__BtnLink-sc-1rxtu35-11 hFwWmH" />
                <div className="sc-404__BtnText-sc-1rxtu35-12 lcKkDD">
                  Back to homepage
                </div>
                <div className="sc-404__BtnArrow-sc-1rxtu35-13 eWjTME">
                  <svg className="sc-404__ArrowImg-sc-1rxtu35-14 hBzdUA">
                    <use href="#proposal-link" />
                  </svg>
                </div>
              </div>
            </div>
          </section>
          {/* <footer className="Footer__LayoutFooter-sc-s51cim-0 cTugls">
            <div className="Footer__FooterContainer-sc-s51cim-1 dATFpT">
              <div className="Container-sc-rx245t-0 dGblwP">
                <div className="Footer__Row-sc-s51cim-2 kVSuGe">
                  <div className="Footer__LogoCol-sc-s51cim-7 jPIwTI">
                    <a
                      className="Footer__FooterLogoLink-sc-s51cim-3 hqJpvX"
                      href="/"
                    >
                      <img
                        alt="logo"
                        src="data:image/svg+xml;base64,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"
                        width={137}
                        height={28}
                      />
                    </a>
                    <div className="Footer__LogoText-sc-s51cim-4 kQCuRa">
                      Secure. Transparent. Lightning fast
                    </div>
                    <div className="Footer__SocialLinks-sc-s51cim-15 cPjuLt">
                      <a
                        href="https://twitter.com/Liquid Marketscom"
                        className="Footer__SocialLink-sc-s51cim-16 fOAHeG"
                      >
                        <div className="Footer__FooterIconContainer-sc-s51cim-17 cEtGEv">
                          <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M9.7431 12.2661L3 3.6875H8.34101L12.5035 8.98963L16.9504 3.71137H19.892L13.9257 10.8013L21 19.8125H15.6749L11.1678 14.0786L6.35607 19.7966H3.39858L9.7431 12.2661ZM16.4511 18.2231L6.27493 5.27695H7.56424L17.7276 18.2231H16.4511Z"
                              fill="#3071EE"
                            />
                          </svg>
                        </div>
                      </a>
                      <a
                        href="https://t.me/Liquid Markets_official"
                        className="Footer__SocialLink-sc-s51cim-16 fOAHeG"
                      >
                        <div className="Footer__FooterIconContainer-sc-s51cim-17 cEtGEv">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m9.778 18.646.282-4.225 7.685-6.934c.337-.3-.074-.446-.522-.174l-9.485 5.984-4.097-1.279c-.885-.27-.891-.879.199-1.316l15.966-6.158c.729-.33 1.433.175 1.154 1.291l-2.72 12.813c-.19.91-.74 1.128-1.501.708l-4.141-3.06-1.992 1.936c-.23.226-.414.414-.828.414z"
                              fill="#3071EE"
                            />
                          </svg>
                        </div>
                      </a>
                      <a
                        href="https://www.facebook.com/Liquid Marketscom"
                        className="Footer__SocialLink-sc-s51cim-16 fOAHeG"
                      >
                        <div className="Footer__FooterIconContainer-sc-s51cim-17 cEtGEv">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 2v4.002h-2c-.69 0-1 .809-1 1.5v2.5h3v4h-3v8L10 22v-7.998H7v-4h3v-4a4 4 0 0 1 4-4L17 2z"
                              fill="#3071EE"
                            />
                          </svg>
                        </div>
                      </a>
                      <a
                        href="https://www.youtube.com/c/Liquid Markets"
                        className="Footer__SocialLink-sc-s51cim-16 fOAHeG"
                      >
                        <div className="Footer__FooterIconContainer-sc-s51cim-17 cEtGEv">
                          <svg
                            viewBox="0 0 23 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#youtubeIcon_svg__a)">
                              <path
                                d="M21.415 6.155c-.24-1.108-.947-1.981-1.845-2.278-1.626-.538-8.15-.538-8.15-.538s-6.522 0-8.149.538c-.897.297-1.604 1.17-1.844 2.278-.436 2.01-.436 6.202-.436 6.202s0 4.192.436 6.202c.24 1.108.947 1.945 1.844 2.241 1.627.539 8.15.539 8.15.539s6.523 0 8.15-.538c.897-.297 1.604-1.134 1.844-2.242.436-2.01.436-6.202.436-6.202s0-4.192-.436-6.202zM9.288 16.163V8.551l5.451 3.806-5.452 3.806z"
                                fill="#3071ee"
                              />
                            </g>
                            <defs>
                              <clipPath id="youtubeIcon_svg__a">
                                <path
                                  fill="#fff"
                                  transform="translate(.42 .339)"
                                  d="M0 0h22v24H0z"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Footer__FooterPrivacy-sc-s51cim-12 ekWFop">
              <div className="Container-sc-rx245t-0 dGblwP">
                <ul className="NavUl-sc-hbrp4m-0 Footer__FooterPrivacyUl-sc-s51cim-13 btfRVJ foNJWL" />
                <div className="Footer__WarningContainer-sc-s51cim-18 cHkgYn">
                  <p className="Footer__WarnigTitle-sc-s51cim-19 dndRNe" />
                </div>
              </div>
            </div>
            <div className="Icons__DisplayNone-sc-g262n3-0 kYhTYJ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <symbol
                  viewBox="0 0 18 12"
                  id="arrow-right"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 5.25v1.5h15.127L11 10.879l1.06 1.06L18 6 12.06.06 11 1.121l4.127 4.129H0z"
                    data-fill="true"
                  ></path>
                </symbol>
                <symbol
                  viewBox="0 0 28 28"
                  id="benefit-bank"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.583 11.667H5.25v8.166h2.333v-8.166zm7 0H12.25v8.166h2.333v-8.166zm9.917 10.5H2.333V24.5H24.5v-2.333zm-2.917-10.5H19.25v8.166h2.333v-8.166zm-8.167-7.864L19.495 7H7.338l6.078-3.197zm0-2.636L2.333 7v2.333H24.5V7L13.416 1.167z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 28 28"
                  id="benefit-rating"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.083 21.572l7-7.012 4.667 4.667 9.916-11.154-1.645-1.645-8.271 9.299-4.667-4.667-8.75 8.762 1.75 1.75z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 28 28"
                  id="benefit-shild"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 1.167L3.5 5.833v7c0 6.475 4.48 12.53 10.5 14 6.02-1.47 10.5-7.525 10.5-14v-7L14 1.167zm0 2.543l8.167 3.64v5.74c0 1.988-.597 3.996-1.58 5.777-1.927-1.435-5.122-1.95-6.587-1.95-1.466 0-4.66.516-6.587 1.953-.985-1.782-1.58-3.792-1.58-5.78V7.35L14 3.709v.001zM14 7a4.083 4.083 0 100 8.167A4.083 4.083 0 0014 7zm0 2.333a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm0 9.917c1.828 0 4.245.713 5.288 1.559C17.845 22.606 15.985 23.97 14 24.5c-1.983-.529-3.842-1.892-5.286-3.689C9.76 19.965 12.17 19.25 14 19.25z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 32 32"
                  id="bitcoin"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.414 13.806c-.473 1.89-3.414.93-4.328.67l.838-3.322c.945.275 3.977.67 3.49 2.652zm-4.74 2.377l-.914 3.672c1.128.29 4.617 1.402 5.135-.67.55-2.164-3.093-2.728-4.22-3.002zm16.107 3.505c-2.042 8.167-10.3 13.135-18.468 11.093S-.818 20.481 1.219 12.312A15.232 15.232 0 0119.688 1.22c8.152 2.041 13.12 10.3 11.092 18.468zM19.368 9.98l.686-2.743-1.677-.38-.67 2.635c-.442-.106-.884-.213-1.341-.304l.67-2.698-1.66-.396-.686 2.728c-.366-.092-.732-.168-1.067-.26l-2.3-.578-.458 1.783s1.25.29 1.22.304c.685.168.807.595.776.976l-1.874 7.512c-.076.213-.32.488-.762.412.015.015-1.219-.305-1.219-.305l-.823 1.904 2.164.55c.411.106.808.212 1.204.304l-.701 2.773 1.676.427.686-2.758c.457.122.899.228 1.325.35l-.685 2.728 1.676.427.7-2.774c2.82.534 4.984.32 5.867-2.255.762-2.057 0-3.276-1.523-4.053 1.097-.29 1.92-.976 2.148-2.469.305-2.027-1.25-3.109-3.352-3.84z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 32 32"
                  id="chart-bell"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.333 25.333v1.334h24v2.666H2.667V2.667h2.666v20c4 0 8-2.667 10.8-7.467 4-6.667 8.4-9.867 13.2-9.867V8C25.6 8 22 10.8 18.533 16.667c-3.467 5.466-8.267 8.666-13.2 8.666z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 16 14"
                  id="coming-soon-like"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.334 6.665A1.333 1.333 0 0014 5.332H9.79l.636-3.046a.995.995 0 00-.272-.917L9.448.665 5.057 5.056a1.33 1.33 0 00-.39.943v6.666A1.333 1.333 0 006 14h6a1.332 1.332 0 001.228-.814l2.012-4.702A1.33 1.33 0 0015.334 8V6.665zM.667 14h2.667V6H.667v8z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="facebook"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 2v4.002h-2c-.69 0-1 .809-1 1.5v2.5h3v4h-3v8L10 22v-7.998H7v-4h3v-4a4 4 0 014-4L17 2z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="medium"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.372 7.3a.775.775 0 00-.252-.653l-1.868-2.25v-.336H8.05l4.482 9.83 3.94-9.83H22v.336l-1.597 1.53a.466.466 0 00-.177.449v11.248c-.029.17.04.343.177.448l1.56 1.53v.337h-7.844v-.336l1.616-1.568c.159-.159.159-.206.159-.448V8.495l-4.492 11.407h-.606L5.566 8.495v7.645c-.043.321.064.645.29.877l2.101 2.549v.336H2v-.336l2.1-2.549c.226-.233.326-.558.272-.877V7.3z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 16 16"
                  id="proposal-link"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 7v2h12.01l-5.505 5.505 1.414 1.414L15.84 8 7.92.08 6.506 1.495 12.01 7H0z"
                    data-fill="true"
                  ></path>
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="reddit"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 12.143a2.183 2.183 0 00-2.186-2.186 2.2 2.2 0 00-1.524.61c-1.505-1.076-3.566-1.775-5.86-1.864l1.004-4.696 3.261.7a1.56 1.56 0 101.56-1.63 1.553 1.553 0 00-1.398.877l-3.638-.771a.382.382 0 00-.395.16.347.347 0 00-.053.144L11.66 8.72c-2.33.072-4.426.77-5.95 1.864a2.201 2.201 0 00-2.898-.126 2.183 2.183 0 00.48 3.693c-.037.215-.054.43-.054.663 0 3.369 3.924 6.11 8.763 6.11 4.84 0 8.764-2.723 8.764-6.11 0-.215-.018-.448-.054-.663A2.208 2.208 0 0022 12.143zm-15.018 1.56a1.56 1.56 0 013.118 0 1.56 1.56 0 01-1.559 1.559c-.86.018-1.559-.7-1.559-1.56zm8.728 4.14c-1.076 1.075-3.119 1.146-3.71 1.146-.61 0-2.652-.09-3.71-1.147a.4.4 0 010-.573.401.401 0 01.574 0c.68.68 2.115.914 3.136.914 1.022 0 2.473-.233 3.136-.914a.402.402 0 01.574 0 .436.436 0 010 .573zm-.287-2.563a1.56 1.56 0 010-3.118c.86 0 1.56.698 1.56 1.558 0 .843-.7 1.56-1.56 1.56z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 9 16"
                  id="right"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.707 8.707a1 1 0 000-1.414L2.343.929A1 1 0 00.93 2.343L6.586 8 .929 13.657a1 1 0 101.414 1.414l6.364-6.364zM7.5 9H8V7h-.5v2z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 32 32"
                  id="shield-account"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 1.333L4 6.667v8c0 7.4 5.12 14.32 12 16 6.88-1.68 12-8.6 12-16v-8L16 1.333zm0 2.907l9.333 4.16v6.56c0 2.272-.681 4.567-1.805 6.603-2.203-1.64-5.853-2.23-7.528-2.23-1.676 0-5.325.591-7.528 2.232-1.125-2.036-1.805-4.333-1.805-6.605V8.4L16 4.239v.001zM16 8a4.667 4.667 0 100 9.334A4.667 4.667 0 0016 8zm0 2.667a2 2 0 110 4 2 2 0 010-4zM16 22c2.09 0 4.852.815 6.044 1.781C20.394 25.836 18.268 27.395 16 28c-2.267-.604-4.39-2.163-6.041-4.216C11.155 22.817 13.909 22 16 22z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 32"
                  id="shield-outline"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 14.667c0 7.4-5.12 14.32-12 16-6.88-1.68-12-8.6-12-16v-8l12-5.334 12 5.334v8zM12 28c5-1.333 9.333-7.281 9.333-13.037V8.4L12 4.244 2.667 8.4v6.564C2.667 20.72 7 26.667 12 28z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="telegram"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.778 18.646l.282-4.225 7.685-6.934c.337-.3-.074-.446-.522-.174l-9.485 5.984-4.097-1.279c-.885-.27-.891-.879.199-1.316l15.966-6.158c.729-.33 1.433.175 1.154 1.291l-2.72 12.813c-.19.91-.74 1.128-1.501.708l-4.141-3.06-1.992 1.936c-.23.226-.414.414-.828.414z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="twitter"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.46 6.012a8.58 8.58 0 01-2.466.676 4.305 4.305 0 001.887-2.374 8.59 8.59 0 01-2.725 1.041 4.292 4.292 0 00-7.313 3.914 12.184 12.184 0 01-8.846-4.483 4.29 4.29 0 001.329 5.729 4.276 4.276 0 01-1.945-.537v.054c0 2.08 1.48 3.814 3.443 4.209a4.295 4.295 0 01-1.939.073 4.296 4.296 0 004.01 2.98 8.61 8.61 0 01-5.33 1.838c-.347 0-.688-.02-1.024-.06A12.147 12.147 0 008.12 21c7.893 0 12.21-6.54 12.21-12.21 0-.187-.004-.372-.012-.556a8.719 8.719 0 002.141-2.222h.001z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="way-account"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 14c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4zm0-2c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zM5 15l-.6-.5C2.4 12.6 1 11.4 1 9.9c0-1.2 1-2.2 2.2-2.2.7 0 1.4.3 1.8.8.4-.5 1.1-.8 1.8-.8C8 7.7 9 8.6 9 9.9c0 1.5-1.4 2.7-3.4 4.6L5 15z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="way-chart"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 6h8v16h-8V6zM2 4h20V2H2v2zm0 4h10V6H2v2zm7 14h3V10H9v12zm-7 0h5V10H2v12z"
                    data-fill="true"
                  ></path>
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="way-shild"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 1L3 5v6c0 5.552 3.839 10.74 9 12 5.161-1.26 9-6.448 9-12V5l-9-4zm-1 6h2v6h-2V7zm0 8h2v2h-2"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="way-widgets"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 3h8v4.343l5.657-5.657 5.657 5.657L16.657 13H21v8h-8v-8h3.657L11 7.343V11H3V3zm0 10h8v8H3v-8z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 24 24"
                  id="multicollateral"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M21 5.69895H2.25V4.93641L18.75 3.59433V4.93641H21V2.64878C21 0.97118 19.6635 -0.206188 18.0315 0.0302009L2.97 2.21718C1.3365 2.45509 0 4.02135 0 5.69895V20.9498C0 21.7588 0.31607 22.5346 0.87868 23.1066C1.44129 23.6786 2.20435 24 3 24H21C21.7956 24 22.5587 23.6786 23.1213 23.1066C23.6839 22.5346 24 21.7588 24 20.9498V8.74913C24 7.94017 23.6839 7.16434 23.1213 6.59233C22.5587 6.02031 21.7956 5.69895 21 5.69895V5.69895ZM18.75 16.3837C18.4544 16.3836 18.1618 16.3243 17.8887 16.2092C17.6157 16.0941 17.3676 15.9255 17.1587 15.7129C16.9498 15.5004 16.7841 15.248 16.671 14.9703C16.558 14.6927 16.4999 14.3951 16.5 14.0946C16.5001 13.794 16.5584 13.4965 16.6716 13.2189C16.7848 12.9413 16.9507 12.6891 17.1598 12.4766C17.3688 12.2642 17.617 12.0957 17.8901 11.9808C18.1632 11.8659 18.4559 11.8068 18.7515 11.8069C19.3484 11.8071 19.9208 12.0484 20.3428 12.4777C20.7648 12.907 21.0017 13.4892 21.0015 14.0961C21.0013 14.703 20.764 15.285 20.3417 15.714C19.9195 16.143 19.3469 16.3839 18.75 16.3837Z"
                    data-fill="true"
                  />
                </symbol>
                <symbol
                  viewBox="0 0 23 25"
                  id="youtube"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#ua)" fill="none">
                    <path
                      d="M21.415 6.155c-.24-1.108-.947-1.981-1.845-2.278-1.626-.538-8.15-.538-8.15-.538s-6.522 0-8.149.538c-.897.297-1.604 1.17-1.844 2.278-.436 2.01-.436 6.202-.436 6.202s0 4.192.436 6.202c.24 1.108.947 1.945 1.844 2.241 1.627.539 8.15.539 8.15.539s6.523 0 8.15-.538c.897-.297 1.604-1.134 1.844-2.242.436-2.01.436-6.202.436-6.202s0-4.192-.436-6.202zM9.288 16.163V8.551l5.451 3.806-5.452 3.806z"
                      data-fill="true"
                    />
                  </g>
                  <defs fill="none">
                    <clipPath id="ua" fill="none">
                      <path
                        transform="translate(.42 .339)"
                        d="M0 0h22v24H0z"
                        data-fill="true"
                      />
                    </clipPath>
                  </defs>
                </symbol>
                <symbol id="plyr-play" viewBox="0 0 18 18">
                  <path d="M15.562 8.1L3.87.225c-.818-.562-1.87 0-1.87.9v15.75c0 .9 1.052 1.462 1.87.9L15.563 9.9c.584-.45.584-1.35 0-1.8z"></path>
                </symbol>
              </svg>
            </div>
          </footer> */}

          <Footer />
        </div>
      </div>
      <div
        id="gatsby-announcer"
        style={{
          position: "absolute",
          top: 0,
          width: 1,
          height: 1,
          padding: 0,
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
        aria-live="assertive"
        aria-atomic="true"
      />
      <div className="Toastify" />
      <div />
    </div>
  );
};

export default Lost;
